import GalleryIcon from '@/assets/all-icons/gallery-icon';

import './styles/GalleryVisitsEmptyState.css';

export default function GalleryVisitsEmptyState({ t }) {
  return (
    <section className="gallery-visits-empty-state" aria-labelledby="gallery-visits-empty-state-title">
      <div className="gallery-visits-empty-state__icon" aria-hidden="true">
        <GalleryIcon />
      </div>

      <h3 id="gallery-visits-empty-state-title" className="gallery-visits-empty-state__title">
        {t('empty')}
      </h3>
      <ol className="gallery-visits-empty-state__steps">
        <li className="gallery-visits-empty-state__step">
          <span className="gallery-visits-empty-state__step-number" aria-hidden="true">1</span>
          <span>{t('empty_step_visit')}</span>
        </li>
        <li className="gallery-visits-empty-state__step">
          <span className="gallery-visits-empty-state__step-number" aria-hidden="true">2</span>
          <span>{t('empty_step_scan')}</span>
        </li>
        <li className="gallery-visits-empty-state__step">
          <span className="gallery-visits-empty-state__step-number" aria-hidden="true">3</span>
          <span>{t('empty_step_rewards')}</span>
        </li>
        <li className="gallery-visits-empty-state__step">
          <span className="gallery-visits-empty-state__step-number" aria-hidden="true">4</span>
          <span>{t('empty_step_saved')}</span>
        </li>
      </ol>
    </section>
  );
}
